import * as React from 'react';
import { Translate } from '../../../../../shared/LanguageService';

type MatterportInProgressProps = {
    // ...
};

export function MatterportInProgress({}: MatterportInProgressProps) {
    return <div>{Translate('order/matterport/in-progress')}</div>;
}
